import { Component } from '@angular/core';
import { CaseNoteService } from '../../../services/case-note.service';
import { HelpService } from '../../../services/help.service';

@Component({
    selector: 'lex-case-notes',
    templateUrl: './case-notes.component.html',
    styleUrls: ['./case-notes.component.scss'],
    standalone: false
})
export class CaseNotesComponent {
	constructor(public caseNoteService: CaseNoteService, public helpService: HelpService) {
		this.caseNoteService.refreshCaseNotes();
		helpService.updateHelpLink('analysis-menu/case-notes');
	}
}
